import { CheckoutFlow } from '@widgets/order-delivery'

export default function CheckoutPage () {
  return <CheckoutFlow />
}
